export default "__VITE_ASSET__WYq3HmiI__"